import {gsap} from "gsap";
import {isMobile, isTablet} from "../components/helpers";

export function initRplLanding() {
    if (!$('#rpl_landing').length) return;
    let percentIphoneImage = ($('.iphone-scroll-image img').height() * 100) / $('.iphone-scroll-image').height();
    let textPins = $('.shifted-block').find('.text-pin');
    let pinsPercent = 100 / textPins.length;

    // wait until window is loaded - all images, styles-sheets, fonts, links, and other media assets
    $(window).on("resize", function () {
        updateComputedValues()
    })
    $(window).on("load", function () {
        updateComputedValues()

        gsap.timeline({
            scrollTrigger: {
                trigger: $('.rpl-scrolled-iphone'),
                scroller: isMobile() || isTablet() ? '' : '.scroller',
                start: () => 'center center',
                pin: '.rpl-scrolled-iphone',
                end: () => `${percentIphoneImage}%`,
                scrub: true,
                //anticipatePin: 1,
                invalidateOnRefresh: true,
            },
        }).to(".iphone-scroll-image img", {
            yPercent: -100,
            y: $('.iphone-scroll-image').height()
        }).to(".shifted-block", {
            yPercent: -100,
            y: $('.iphone-scroll-image').height(),
        }, "<")

        let startTop = 0;

        for (let i = 0; i < textPins.length; i++) {
            startTop = Math.floor(pinsPercent * i);
            if (i === 0) startTop = 1;
            if (i === 1) startTop = startTop + 7;
            if (i === 2) startTop = startTop + 3;
            if (i === 3) startTop = startTop + 8;
            if (i === 4) startTop = startTop + 5;
            if (i === textPins.length - 1) startTop = 90;

            $($('.shifted-block .text-pin')[i]).css({
                'top': startTop + '%'
            });
            gsap.timeline({
                scrollTrigger: {
                    scroller: isMobile() || isTablet() ? '' : '.scroller',
                    trigger: textPins[i],
                    scrub: true,
                    start: i < textPins.length - 1 ? `top bottom-=${startTop}%` : `top bottom`,
                    end: i < textPins.length - 1 ? `bottom top-=${startTop + 10}%` : `bottom top-=300%`,
                    invalidateOnRefresh: true
                }
            }).to(textPins[i], {
                autoAlpha: 1,
            }).to(textPins[i], {
                autoAlpha: 0
            })
        }

        const rplBubbles = gsap.utils.toArray('.bubbles-background .bubble-item');

        const bubblesTimeline = gsap.timeline({
            paused: true
        })

        rplBubbles.forEach((item, index) => {
            bubblesTimeline.to(item, {
                scale: 1,
                x: $(item).hasClass('item2') ? '-50%' : '0'
            })
        })

        if (!isMobile()) {
            const rplIphones = gsap.utils.toArray('.rpl-iphones-block .iphone-plug');
            const rplIphonesLength = rplIphones.length;
            const percent = 100 / rplIphonesLength;

            rplIphones.forEach((item, index) => {
                const realIndex = +$(item).attr('data-item') || 0;
                let x = -(index + 1) * 110;
                let delay = index / percent;
                let mobileX = -100;
                let mobileXto = 30;

                if ($(item).hasClass('from-right')) {
                    x = (rplIphonesLength - index + 1) * 110;
                    delay = (rplIphonesLength - realIndex) / percent;
                    mobileX = 100;
                    mobileXto = -30;
                }

                gsap.timeline({
                    scrollTrigger: {
                        trigger: item,
                        scroller: isMobile() || isTablet() ? '' : '.scroller',
                        start: `top-=110% bottom`,
                        end: `bottom-=10% top`,
                        scrub: isMobile() ? true : 0.8,
                    },
                }).from($(item), {
                    ease: "none",
                    x: `${x}%`,
                    willChange: 'transform',
                    onStart: () => {
                        if (index === 0) bubblesTimeline.play()
                    },
                    onComplete: () => {
                        gsap.to($(item).find('.pipka'), {
                            border: '0.5px dashed #A4A4A4',
                            height: '100%',
                            delay: 0,
                        })
                        gsap.to($(item).find('.shapka'), {
                            height: '50%',
                            delay: 0,
                        })
                        gsap.to($(item).find('.text'), {
                            scale: 1,
                            delay: 0,
                        })

                    }
                }).to($(item), {
                    //translateX: isMobile()?mobileXto:'0%',
                    willChange: 'auto',
                    onReverseComplete: () => {
                        gsap.to($(item).find('.pipka'), {
                            border: 0,
                            delay: 0,
                            height: '0%',
                        })
                        gsap.to($(item).find('.shapka'), {
                            height: '0%',
                            delay: 0,
                        })
                        gsap.to($(item).find('.text'), {
                            scale: 0,
                            delay: 0,
                        })
                    }
                })
            })
        }
    });

    function updateComputedValues() {
        percentIphoneImage = ($('.iphone-scroll-image img').height() * 100) / $('.iphone-scroll-image').height();
        $('.shifted-block').height($('.iphone-scroll-image img').height());
        textPins = $('.shifted-block').find('.text-pin');
        pinsPercent = 100 / textPins.length;
    }

}
